<template>
  <div class="headers">
    <div class="headers-left">
      <div class="headers-left-box" :class="asideShow === false ? 'headers-left-active' : ''" @click="targetIcon">
        <i class="el-icon-s-fold"></i>
      </div>
      <Breadcrumb/>
    </div>
    <div class="headers-right">
      <div class="headers-right-left">

        <!-- 通知栏 -->
        <div class="header-right-dropdown" @mouseover="dropdownBtn" @mouseout="dropShow = false">
          <el-collapse-transition>
            <Dropdowns v-show="dropShow"/>
          </el-collapse-transition>
        </div>

      </div>
      <ul class="headers-right-right">
        <li class="headers-right-avatar">
          <el-avatar shape="square" size="medium" :src="squareUrl"></el-avatar>
        </li>
        <li>
<!--            <span class="el-dropdown-link">{{name}}</span>-->
          <el-dropdown size="medium" @command="handleCommand">
            <span class="el-dropdown-link">
                {{name}}
                <i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
               <el-dropdown-item command="github">修改密码</el-dropdown-item>
              <el-dropdown-item divided command="quit">退出登录</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </li>

      </ul>

    </div>
    <el-drawer
      :with-header="false"
      :visible.sync="theme"
      direction="rtl"
      size='400px'
      class="theme"
    >
      <div class="theme-title">配色方案</div>
      <div class="theme-title-box">
        <div class="theme-title-box-list" v-for="(item,index) in themeColor" :key="index"
             @click="targetThemeIndex(index)" :class="themeIndex === index ? 'theme-active' : ''">
          <div class="theme-title-box-list-left" :style="item.aside"></div>
          <div class="theme-title-box-list-right">
            <div class="theme-title-box-list-right-top" :style="item.header"></div>
            <div class="theme-title-box-list-right-bottom" :style="item.container"></div>
          </div>
        </div>
      </div>
    </el-drawer>
    <el-dialog
      title="密码修改"
      :visible.sync="modifyPawDialog"
      center
      width="460px"
      :close-on-click-modal="false"
      :before-close="handleClose">
      <el-form :model="passForm" status-icon :rules="passFormRules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
        <el-form-item label="当前密码" prop="pass">
          <el-input type="password" v-model="passForm.pass" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="新密码" prop="newSass">
          <el-input type="password" v-model="passForm.newSass" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="确认密码" prop="checkPass">
          <el-input type="password" v-model="passForm.checkPass" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item align="center">
          <el-button type="primary" @click="submitForm('ruleForm')">提交</el-button>
          <el-button @click="resetForm('ruleForm')">重置</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>


<script>
  // 全屏组件
  import screenfull from 'screenfull'

  // 面包屑
  import Breadcrumb from '../Breadcrumb/Breadcrumb2'

  // 通知栏组件
  import Dropdowns from '../Dropdown/index'
  import squareUrl from '../../assets/image/user.png'
  import store from '../../store/index'

  export default {
    props: {
      asideShow: {
        type: Boolean,
        default: true
      },
      themeColor: {
        type: Array,
      },
      themeIndex: {
        type: Number,
      }
    },
    data () {
      let validatePass = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请输入密码'));
        } else {
          if (this.passForm.checkPass !== '') {
            this.$refs.ruleForm.validateField('checkPass');
          }
          callback();
        }
      };
      let validatePass2 = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请再次输入密码'));
        } else if (value !== this.passForm.newSass) {
          callback(new Error('两次输入密码不一致!'));
        } else {
          callback();
        }
      };
      return {
        squareUrl,
        isFullscreen: false,
        dropShow: false, // 是否现实通知栏
        setTime: null, //定时器
        theme: false, // 主题 开关
        name: "",
        modifyPawDialog:false,
        passForm:{
          pass:'',
          newSass:'',
          checkPass:'',
        },
        passFormRules:{
          pass: [
            {  trigger: 'blur' }
          ],
          newSass: [
            { validator: validatePass, trigger: 'blur' }
          ],
          checkPass: [
            { validator: validatePass2, trigger: 'blur' }
          ]
        },
      }
    },
    components: {
      Breadcrumb,
      Dropdowns,
    },
    computed: {
      userInfo: function() {
        return JSON.parse(window.localStorage.getItem("userInfo"));
      }
    },
    methods: {
      // 自定义 切换 侧边栏 事件
      targetIcon () {
        this.$emit('targetIcon', !this.asideShow)
      },
      // 全屏
      buttoncli () {
        // if (!screenfull.enabled) { // 如果不允许进入全屏，发出不允许提示
        //     this.$message({
        //         message: '不支持全屏',
        //         type: 'warning'
        //     })
        //     return false
        // }
        screenfull.toggle()
        this.checkFull()
      },
      // 监控屏幕变化
      checkFull () {
        var isFull = document.fullscreenEnabled || window.fullScreen || document.webkitIsFullScreen || document.msFullscreenEnabled;
        // to fix : false || undefined == undefined
        // 是否全屏判断
        this.isFullscreen = !this.isFullscreen;
        if (this.isFullscreen) {
          this.$message({
            message: '全屏啦',
            type: 'success'
          })
        } else {
          this.$message({
            message: '取消全屏',
            type: 'warning'
          })
        }

        if (isFull === undefined) {
          isFull = false;
        }
        return isFull;
      },
      // 用户名 下拉菜单
      handleCommand (command) {

        switch (command) {
          case 'github':
            this.openModifyPawDialog()
            break;
          case 'quit':
            this.quits()
            break;

        }
      },
      // 退出登陆
      quits () {
        this.$confirm(
          "是否退出",
          "提示",
          {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          }
        )
          .then(() => {
            store.dispatch('user/resetToken').then(() => {
              location.reload()
            })
          })
          .catch(() => {
          });

      },
      // 展开通知
      dropShowBtn () {
        clearTimeout(this.setTime)
        this.dropShow = true
      },
      // 收起通知
      dropHideBtn () {
        let This = this

        this.setTime = setTimeout(function () {
          This.dropShow = false;
        }, 1000)
      },
      // 鼠标移入 通知栏
      dropdownBtn () {
        clearTimeout(this.setTime)
        this.dropShow = true
      },
      // 选取配色方案
      targetThemeIndex (index) {
        this.$emit('targetThemeIndex', index)
      },
      // 去github
      goGithub () {
        window.open('https://github.com/cgq001/admin-menu/tree/2.0')
      },
      openModifyPawDialog(){
        this.modifyPawDialog = true
      },
      handleClose(){
        this.modifyPawDialog = false
      },
      //修改密码
      submitForm(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            var data = {
              Id: this.userInfo.id,
              Password: this.passForm.pass,
              PasswordNew: this.passForm.newSass
            };
            this.updatePassword(data);
          } else {
            console.log('error submit!!');
            return false;
          }
        });
      },
      resetForm(formName) {
        this.$refs[formName].resetFields();
      },
      async updatePassword(data){
        var res = await this.$post(
          '/SysUserInfo/UpdatePassword',
          data
        );
        if(res.code == 0){
          this.$message({
            message: "修改成功",
            type: "success"
          });

          this.modifyPawDialog = false;
          this.passForm.pass = '';
          this.passForm.newSass = '';
          this.passForm.checkPass = '';
        }
      }

    },
    mounted () {
      // 浏览器窗口改变事件
      this.isFullscreen = document.body.scrollHeight === window.screen.height
      this.name = JSON.parse(localStorage.getItem('userInfo')).name
      // console.log('2222',JSON.parse(localStorage.getItem('userInfo')).name)
    }
  }
</script>

<style scoped>
  .headers {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: space-between;
  }

  .headers-left {
    display: flex;
    justify-content: flex-start;
    flex: 1;
    padding-left: 10px;
  }

  .headers-left-box {
    transition: all 0.5s;
    transform-origin: center center;
    width: 20px;
    height: 100%;
    margin-right: 15px;
    display: inline-block;
  }

  .headers-left-active {
    transform: rotate(180deg);
  }

  .el-icon-s-fold {
    width: 20px;
    height: 100%;
    line-height: 50px;
    font-size: 20px;
    cursor: pointer;

  }

  .headers-right {
    height: 100%;

  }

  .headers-right-left {
    margin-right: 30px;
    font-size: 22px;
    cursor: pointer;
    position: relative;
  }

  .headers-right-left-screenIcon {
    width: 18px;
    height: 18px;
    margin-right: 10px;
    fill: currentColor;
    color: #413A3F;
  }

  .headers-right-left-aimIcon {
    font-size: 22px;
    color: #413A3F;
    margin: 0 20px;
  }

  .headers-right-left-githubIcon {
    width: 20px;
    height: 20px;
    margin-right: 20px;
    fill: currentColor;
    color: #413A3F;
  }

  .header-right-dropdown {
    width: 300px;
    height: auto;
    position: absolute;
    right: 0;
    top: 60px;
    z-index: 2;
    background: #ffffff;
    /* padding: 5px 0; */
    box-sizing: border-box;
    border-radius: 4px;
    box-shadow: 0 1px 6px rgba(0, 0, 0, .2);
    overflow: hidden;
  }

  /* .head-news-icon{

  } */
  .head-screen {
    margin-right: 15px;
    transform: rotate(45deg);
  }

  .head-screen-news {
    margin-right: 15px;
  }

  .headers-right-right {
    display: flex;
    align-items: center;
    color: #666666;
    height: 100%;
    padding-right: 15px;
  }

  .headers-right-right li {
    /*align-self: center;*/
  }

  .headers-right-avatar {
    margin-right: 6px;
    display: flex;
    align-items: center;
  }

  .headers-right-avatar .el-avatar {
    background-color: #fff;
  }

  .el-dropdown-link {
    cursor: pointer;
    color: #fff;
  }

  .focusing {
    border: none !important;
  }

  /* 主题 */
  .theme {
    height: 100vh;
    overflow: hidden;
  }

  .el-drawer__body {
    height: 100vh !important;
    overflow: hidden;
  }

  .theme-title {
    width: 100%;
    height: 50px;
    line-height: 50px;
    font-size: 16px;
    font-weight: bold;
    padding: 0 15px;
    border-bottom: 1px solid #dcdfe6;
  }

  .theme-title-box {
    padding: 10px;
    box-sizing: border-box;
    width: 100%;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    height: calc(100vh - 51px);
    overflow-x: hidden;
    overflow-y: auto;
    -ms-overflow-style: none;
    overflow: '-moz-scrollbars-none';
    scrollbar-width: none; /*  火狐   */
    background: #F5F7F9;
  }

  .theme-title-box::-webkit-scrollbar {
    display: none; /*  Chrome  */
    width: 0 !important; /*  Chrome  */
  }

  .theme-title-box-list {
    width: 180px;
    height: 150px;
    display: flex;
    padding: 10px;
    box-sizing: border-box;
    background: #999999;
    border-radius: 5px;
    cursor: pointer;
    margin-bottom: 10px;
    border: 5px solid transparent;
  }

  .theme-title-box-list-left {
    width: 30px;
    height: 120px;
  }

  .theme-title-box-list-right {
    flex: 1;
    height: 160px;
  }

  .theme-title-box-list-right-top {
    width: 100%;
    height: 20px;
    background: #ffffff;
  }

  .theme-title-box-list-right-bottom {
    width: 100%;
    height: 100px;
  }

  .theme-active {
    border: 5px solid #05DA89;
  }
</style>
